export const FULLSTORY_EXCLUDE = 'fs-exclude';
